import { StyleSheet, Path } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    pageNumbers: {
        fontSize: 8,
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center'
    },

    body: {
        paddingTop: 12,
        paddingBottom: 12,
        paddingHorizontal: 6,
    },
    h2: {
        fontSize: '14px',
        margin: 6,
        fontWeight: 'bold',
        fontFamily: 'Roboto',
        color: '#6B2FA0',
    },
    text: {
        margin: 6,
        fontSize: 8,
        textAlign: 'justify',
        fontFamily: 'Roboto',
        color: '#5A5A5A',

        bold: {
            fontWeight: 'bold',
            color: 'black',
            fontFamily: 'Roboto'
        },

        blue: {
            margin: 6,
            fontSize: 8,
            fontWeight: 'bold',
            color: '#451D73',
            fontFamily: 'Roboto'
        },

        green: {
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
            color: '#ACFF23',
            fontWeight: 'bold',
            justifyContent: 'center',
            fontFamily: 'Roboto',
            fontSize: '10px',
            marginBottom: '8px',
        }
    },

    page: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
    },

    // Container 2 linha do pdf contendo os cards
    // com valor, acuracia e top

    containerCard: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap'
    },

    card: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#451d73',
        margin: '5px',
        borderRadius: '6px',
        padding: '4px',
        maxWidth: '100px',
        height: '30px',
        flex: '1 0 16%',

        titulo: {
            color: '#acff23',
            fontWeight: 'bold',
            fontSize: '10px',
            padding: '0 0 10'
        },

        container: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            fontSize: '6px',
            color: '#ffffff',
            flexDirection: 'row',
            fontWeight: 'bold'
        },

        columnValor: {
            display: 'flex',
            flexDirection: 'row',
            borderRight: '1 solid #ffffff',
            width: '100%',
            textAlign: 'center',
            color: '#FFFFFF',
            justifyContent: 'center',
            alignItems: 'center'
        },

        columnAcuracia: {
            display: 'flex',
            flexDirection: 'row',
            borderRight: '1 solid #ffffff',
            width: '100%',
            textAlign: 'center',
            color: '#FFFFFF',
            justifyContent: 'center',
            alignItems: 'center'
        },

        columnTop:
        {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            textAlign: 'center',
            color: '#FFFFFF',
            justifyContent: 'center',
            alignItems: 'center'
        },
    },

    containerCardLegend:
    {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#6B2FA0',
        border: '1 solid #D1CFD7',
        borderRadius: '6px',
        padding: '13',
        alignItems: 'center',
        width: '100%',
        margin: '5',
        justifyContent: 'space-between',
    },

    containerCardLegendText:
    {
        color: '#ffffff',
        fontSize: '8',
        fontWeight: 'bold'
    },

    containerCardSmall: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        margin: '3',
    },

    cardSmall: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        backgroundColor: '#6b2fa0',
        margin: '2',
        borderRadius: '6px',
        padding: '4px ',
        maxWidth: '40.83',
        height: '35',
        flex: '1 0 6.5%'
    },

    cardSmallText: {
        width: '100%',
        textAlign: 'center',
        color: '#ffffff',
        fontSize: '8'
    },

    // Fim Container 2
    // Genealogia


    genealogia: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        paddingTop: '12px',

        container: {
            width: '100%',
            padding: '25px 6px',
        },

        columns: {
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            flexDirection: 'column',
            minHeight: '10'
        },

        card: {
            minWidth: '136',
            maxWidth: '136',
            width: '100%',
            padding: '6px',
        },

        content: {
            display: 'flex',
            padding: '0',
            backgroundColor: '#ffffff',
            border: '0 solid #c4c4c4',
            position: 'relative',
            borderRadius: '6px',
        },

        header: {
            flexDirection: 'row',
            justifyContent: 'center',
            backgroundColor: '#451D73',
            padding: '6',
            width: '100%',
            textAlign: 'center',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px'
        },

        headerText: {
            fontSize: '11px',
            color: '#acff23',
            margin: '0',
            fontFamily: 'Roboto'
        },

        body: {
            borderBottomLeftRadius: '6px',
            borderBottomRightRadius: '6px',
            padding: '6px'
        },

        blue: {
            backgroundColor: '#DFF4FF',
            border: '1 solid #7A3FC7',
        },

        pink: {
            backgroundColor: '#FFF2F2',
            border: '1 solid #FFCDCD',
        },

        bodyContent: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '4px'
        },

        bodyContentText: {
            fontSize: '6px',
            fontWeight: '700'
        },
    },

    // Fim genealogia

    //DEPs gráfica

    deps: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 12
    },

    depsContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '45%',
        borderRadius: '8px',
        border: '1px solid #D1CFD7',
        padding: '8px 4px 4px 4px',
    },

    depsLegenda: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: '5',
        fontFamily: 'Roboto',
    },

    depsTitle: {
        paddingLeft: '12px',
        fontSize: '14px',
        fontWeight: 'bold'
    },

    depsText: {
        marginLeft: '2px',
        fontSize: '10px',
        padding: '5',
        fontFamily: 'Roboto',
    },

    chartView: {
        width: '100%',
    },

    chart: {
        width: '100%',
    },

    chartWrap: {
        display: 'flex',
        flexDirection: 'row',
    },

    headerWrap: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '16px',
        paddingRight: '16px',
        marginBottom: '8px'
    },

    chartRow: {
        width: '16%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '5px'
    },

    barWrap: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: '1px'
    },

    chartLabel: {
        fontSize: 8,
        fontWeight: 'bold',
        width: '40px',
        textAlign: 'right'
    },

    chartData: {
        width: '60%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        borderLeft: '1px solid #000',
        borderBottom: '1px solid #000',
        paddingBottom: '2px'
    },

    chartBar: {
        height: 8,
        borderTop: '1px solid #000',
        borderRight: '1px solid #000',
        borderBottom: '1px solid #000',
        marginRight: '4px',
        height: '8px',
    },

    chartValue: {
        fontSize: 4,
    },


    container: {
        display: 'flex',
        flexDirection: 'column',
        alignITems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',

        titulo: {
            backgroundColor: '#451d73',
            color: '#ffffff',
            padding: '8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            borderRadius: '6px',

            texto: {
                fontSize: '12px',
                marginTop: '2',
                marginBottom: '2',
                fontWeight: 'bold',
                fontFamily: 'Roboto',
            }
        },

        secondary: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-evenly',
            background: '#ffffff',
            boxSizing: 'border-box',
            listStyle: 'none',
            margin: '0',
            padding: '0',
            width: '100%',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            borderBottomLeftRadius: '15px',
            borderBottomRightRadius: '15px',
            border: '1px solid #D1CFD7',

            row: {
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                padding: '12px 8px',
                gap: '8px',

                columns: {
                    width: '100%',
                    height: '120',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flex: '1 0 22%',

                    image: {
                        minHeight: '120',
                        borderRadius: '8px'
                    },

                    row: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        width: '100%',
                        li: {
                            width: '45%'
                        }

                    },

                    mgte: {
                        width: '100%',
                        height: '40px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        backgroundColor: '#451d73',
                        padding: '6px',
                        borderRadius: '6px',
                        flexDirection: 'column',
                        alignItems: 'center',
                    },
                }
            }
        }
    },

    mgteContent: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    },

    mgteValor: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '8px',
        width: '100%',
        alignItems: 'center',
    },

    image: {
        minWidth: '190',
        minHeight: '160',
    }
});

export const svgIcons = [
    {
        name: 'Diamante',
        color: '#A2A3A7',
        icon: <Path d='M28.6455 10.7151C27.4001 12.3703 25.5022 14.4394 22.9223 16.9223C19.9865 19.7304 17.9997 21.7404 16.9914 22.9523H0.029264C-0.119007 22.4202 0.296151 21.5926 1.27474 20.4102C2.66848 18.8436 5.54494 15.6809 9.93376 10.9811C13.8185 6.81336 16.6949 3.56192 18.5928 1.28593C21.3803 3.73927 24.7312 6.90203 28.6455 10.7151ZM25.8284 27.0313C27.1925 31.8198 29.1793 39.1207 31.7592 48.9637C34.3688 58.7475 36.3556 66.0484 37.7494 70.896C37.3342 71.1325 35.8515 69.6545 33.3309 66.4918C30.5731 63.063 25.2353 56.5306 17.3176 46.865C10.3786 38.4113 5.01116 31.7902 1.24508 27.0017H25.8284V27.0313ZM31.4923 13.8187C35.7032 16.8041 38.9652 19.8486 41.2189 22.9523H23.2781C23.1892 22.3906 23.5747 21.7108 24.405 20.9127C24.5829 20.7354 24.9981 20.3807 25.5912 19.9077C26.1249 19.4643 26.5104 19.1097 26.7773 18.8436C27.4297 18.1933 28.2304 17.3657 29.209 16.3016C30.3062 15.0602 31.0772 14.2325 31.4923 13.8187ZM35.9108 4.12355C34.1019 6.01528 32.6192 7.25673 31.4923 7.90702C30.8993 7.37497 29.5352 6.10396 27.489 4.06442C25.858 2.43871 24.4643 1.19727 23.3078 0.340072C25.1167 0.0740458 27.6966 -0.0441987 30.9882 0.0149182C35.4363 0.103593 38.1052 0.103597 39.0245 0.0740386C39.2321 0.369623 38.1942 1.72931 35.9108 4.12355ZM59.1597 27.0313C52.6654 51.2397 47.9504 68.886 45.0146 80C44.4512 79.261 43.0871 74.9751 40.952 67.1421C38.6983 59.0135 35.1101 45.9783 30.2469 28.0067V27.0609H59.1597V27.0313ZM34.6653 11.0107C34.5764 10.5082 35.2584 9.65097 36.6522 8.40952C36.9784 8.08437 37.5121 7.61144 38.2238 6.99072C38.8169 6.48822 39.2024 6.19263 39.3507 6.04484C41.812 3.4437 43.354 1.78843 44.036 1.01991C45.7263 1.81799 47.6242 3.32546 49.7593 5.54235C52.1613 8.02525 53.9405 9.65097 55.0674 10.3899C53.9998 11.6018 52.3985 13.2571 50.2041 15.4149C47.9504 17.6317 46.2898 19.3166 45.2815 20.4398C45.2519 20.4398 42.6423 18.0456 37.4825 13.2275C37.3639 13.1389 36.8301 12.7842 35.8515 12.1043C35.0508 11.5131 34.6653 11.1584 34.6653 11.0107ZM57.5583 13.5527C59.0707 14.3803 60.85 15.8582 62.8664 18.016C65.0905 20.3216 66.7808 21.8586 67.967 22.6271C65.7429 22.9227 62.6589 23.0409 58.6852 22.9523C53.4068 22.9227 50.2041 22.9227 49.0773 22.9523C48.9883 22.3611 49.3738 21.6812 50.2041 20.9127C50.382 20.7354 50.7675 20.3807 51.331 19.9077C51.8647 19.4643 52.2502 19.1097 52.5171 18.8436C52.9619 18.4594 54.6226 16.7154 57.5583 13.5527ZM57.5583 7.55231C56.8763 6.9907 55.6012 5.77882 53.7033 3.88708C52.1613 2.32049 50.8268 1.13815 49.7 0.340072C51.3903 0.0740458 53.8516 -0.0441987 57.0542 0.0149182C61.3244 0.103593 63.9043 0.103597 64.794 0.0740386C64.9719 0.517415 64.6753 1.13814 63.8747 1.93622C63.6375 2.11357 63.2816 2.43871 62.7478 2.88209C62.2141 3.29591 61.8285 3.62105 61.621 3.82796C59.2783 6.22219 57.9142 7.46364 57.5583 7.55231ZM88.0725 27.0313C88.2207 27.4747 88.0725 27.9476 87.6277 28.4501C87.509 28.5979 87.3311 28.7753 87.0642 29.0117C86.7973 29.2482 86.6194 29.396 86.5008 29.5142C74.0164 44.5594 62.392 58.8657 51.6572 72.4922C53.5847 62.797 57.5583 47.6335 63.6078 27.0313H88.0725ZM61.0279 10.7151C61.8582 9.59185 65.0015 6.34043 70.4876 1.01991C79.8286 10.922 86.3525 18.2229 90 22.9523C88.0725 22.6567 85.285 22.6862 81.6375 23.0705C78.3163 23.3956 75.855 23.3661 74.2833 22.9523C73.5419 22.7158 71.1993 20.7354 67.3146 16.9815C63.7561 13.4936 61.6506 11.3949 61.0279 10.7151Z' fill='#A2A3A7' />
    },
    {
        name: 'Esmeralda',
        color: '#A8DCA8',
        icon: <Path d='M28.6455 10.7151C27.4001 12.3703 25.5022 14.4394 22.9223 16.9223C19.9865 19.7304 17.9997 21.7404 16.9914 22.9523H0.029264C-0.119007 22.4202 0.296151 21.5926 1.27474 20.4102C2.66848 18.8436 5.54494 15.6809 9.93376 10.9811C13.8185 6.81336 16.6949 3.56192 18.5928 1.28593C21.3803 3.73927 24.7312 6.90203 28.6455 10.7151ZM25.8284 27.0313C27.1925 31.8198 29.1793 39.1207 31.7592 48.9637C34.3688 58.7475 36.3556 66.0484 37.7494 70.896C37.3342 71.1325 35.8515 69.6545 33.3309 66.4918C30.5731 63.063 25.2353 56.5306 17.3176 46.865C10.3786 38.4113 5.01116 31.7902 1.24508 27.0017H25.8284V27.0313ZM31.4923 13.8187C35.7032 16.8041 38.9652 19.8486 41.2189 22.9523H23.2781C23.1892 22.3906 23.5747 21.7108 24.405 20.9127C24.5829 20.7354 24.9981 20.3807 25.5912 19.9077C26.1249 19.4643 26.5104 19.1097 26.7773 18.8436C27.4297 18.1933 28.2304 17.3657 29.209 16.3016C30.3062 15.0602 31.0772 14.2325 31.4923 13.8187ZM35.9108 4.12355C34.1019 6.01528 32.6192 7.25673 31.4923 7.90702C30.8993 7.37497 29.5352 6.10396 27.489 4.06442C25.858 2.43871 24.4643 1.19727 23.3078 0.340072C25.1167 0.0740458 27.6966 -0.0441987 30.9882 0.0149182C35.4363 0.103593 38.1052 0.103597 39.0245 0.0740386C39.2321 0.369623 38.1942 1.72931 35.9108 4.12355ZM59.1597 27.0313C52.6654 51.2397 47.9504 68.886 45.0146 80C44.4512 79.261 43.0871 74.9751 40.952 67.1421C38.6983 59.0135 35.1101 45.9783 30.2469 28.0067V27.0609H59.1597V27.0313ZM34.6653 11.0107C34.5764 10.5082 35.2584 9.65097 36.6522 8.40952C36.9784 8.08437 37.5121 7.61144 38.2238 6.99072C38.8169 6.48822 39.2024 6.19263 39.3507 6.04484C41.812 3.4437 43.354 1.78843 44.036 1.01991C45.7263 1.81799 47.6242 3.32546 49.7593 5.54235C52.1613 8.02525 53.9405 9.65097 55.0674 10.3899C53.9998 11.6018 52.3985 13.2571 50.2041 15.4149C47.9504 17.6317 46.2898 19.3166 45.2815 20.4398C45.2519 20.4398 42.6423 18.0456 37.4825 13.2275C37.3639 13.1389 36.8301 12.7842 35.8515 12.1043C35.0508 11.5131 34.6653 11.1584 34.6653 11.0107ZM57.5583 13.5527C59.0707 14.3803 60.85 15.8582 62.8664 18.016C65.0905 20.3216 66.7808 21.8586 67.967 22.6271C65.7429 22.9227 62.6589 23.0409 58.6852 22.9523C53.4068 22.9227 50.2041 22.9227 49.0773 22.9523C48.9883 22.3611 49.3738 21.6812 50.2041 20.9127C50.382 20.7354 50.7675 20.3807 51.331 19.9077C51.8647 19.4643 52.2502 19.1097 52.5171 18.8436C52.9619 18.4594 54.6226 16.7154 57.5583 13.5527ZM57.5583 7.55231C56.8763 6.9907 55.6012 5.77882 53.7033 3.88708C52.1613 2.32049 50.8268 1.13815 49.7 0.340072C51.3903 0.0740458 53.8516 -0.0441987 57.0542 0.0149182C61.3244 0.103593 63.9043 0.103597 64.794 0.0740386C64.9719 0.517415 64.6753 1.13814 63.8747 1.93622C63.6375 2.11357 63.2816 2.43871 62.7478 2.88209C62.2141 3.29591 61.8285 3.62105 61.621 3.82796C59.2783 6.22219 57.9142 7.46364 57.5583 7.55231ZM88.0725 27.0313C88.2207 27.4747 88.0725 27.9476 87.6277 28.4501C87.509 28.5979 87.3311 28.7753 87.0642 29.0117C86.7973 29.2482 86.6194 29.396 86.5008 29.5142C74.0164 44.5594 62.392 58.8657 51.6572 72.4922C53.5847 62.797 57.5583 47.6335 63.6078 27.0313H88.0725ZM61.0279 10.7151C61.8582 9.59185 65.0015 6.34043 70.4876 1.01991C79.8286 10.922 86.3525 18.2229 90 22.9523C88.0725 22.6567 85.285 22.6862 81.6375 23.0705C78.3163 23.3956 75.855 23.3661 74.2833 22.9523C73.5419 22.7158 71.1993 20.7354 67.3146 16.9815C63.7561 13.4936 61.6506 11.3949 61.0279 10.7151Z' fill='#75C775' />
    },
    {
        name: 'Rubi',
        color: '#F65A70',
        icon: <Path d='M28.6455 10.7151C27.4001 12.3703 25.5022 14.4394 22.9223 16.9223C19.9865 19.7304 17.9997 21.7404 16.9914 22.9523H0.029264C-0.119007 22.4202 0.296151 21.5926 1.27474 20.4102C2.66848 18.8436 5.54494 15.6809 9.93376 10.9811C13.8185 6.81336 16.6949 3.56192 18.5928 1.28593C21.3803 3.73927 24.7312 6.90203 28.6455 10.7151ZM25.8284 27.0313C27.1925 31.8198 29.1793 39.1207 31.7592 48.9637C34.3688 58.7475 36.3556 66.0484 37.7494 70.896C37.3342 71.1325 35.8515 69.6545 33.3309 66.4918C30.5731 63.063 25.2353 56.5306 17.3176 46.865C10.3786 38.4113 5.01116 31.7902 1.24508 27.0017H25.8284V27.0313ZM31.4923 13.8187C35.7032 16.8041 38.9652 19.8486 41.2189 22.9523H23.2781C23.1892 22.3906 23.5747 21.7108 24.405 20.9127C24.5829 20.7354 24.9981 20.3807 25.5912 19.9077C26.1249 19.4643 26.5104 19.1097 26.7773 18.8436C27.4297 18.1933 28.2304 17.3657 29.209 16.3016C30.3062 15.0602 31.0772 14.2325 31.4923 13.8187ZM35.9108 4.12355C34.1019 6.01528 32.6192 7.25673 31.4923 7.90702C30.8993 7.37497 29.5352 6.10396 27.489 4.06442C25.858 2.43871 24.4643 1.19727 23.3078 0.340072C25.1167 0.0740458 27.6966 -0.0441987 30.9882 0.0149182C35.4363 0.103593 38.1052 0.103597 39.0245 0.0740386C39.2321 0.369623 38.1942 1.72931 35.9108 4.12355ZM59.1597 27.0313C52.6654 51.2397 47.9504 68.886 45.0146 80C44.4512 79.261 43.0871 74.9751 40.952 67.1421C38.6983 59.0135 35.1101 45.9783 30.2469 28.0067V27.0609H59.1597V27.0313ZM34.6653 11.0107C34.5764 10.5082 35.2584 9.65097 36.6522 8.40952C36.9784 8.08437 37.5121 7.61144 38.2238 6.99072C38.8169 6.48822 39.2024 6.19263 39.3507 6.04484C41.812 3.4437 43.354 1.78843 44.036 1.01991C45.7263 1.81799 47.6242 3.32546 49.7593 5.54235C52.1613 8.02525 53.9405 9.65097 55.0674 10.3899C53.9998 11.6018 52.3985 13.2571 50.2041 15.4149C47.9504 17.6317 46.2898 19.3166 45.2815 20.4398C45.2519 20.4398 42.6423 18.0456 37.4825 13.2275C37.3639 13.1389 36.8301 12.7842 35.8515 12.1043C35.0508 11.5131 34.6653 11.1584 34.6653 11.0107ZM57.5583 13.5527C59.0707 14.3803 60.85 15.8582 62.8664 18.016C65.0905 20.3216 66.7808 21.8586 67.967 22.6271C65.7429 22.9227 62.6589 23.0409 58.6852 22.9523C53.4068 22.9227 50.2041 22.9227 49.0773 22.9523C48.9883 22.3611 49.3738 21.6812 50.2041 20.9127C50.382 20.7354 50.7675 20.3807 51.331 19.9077C51.8647 19.4643 52.2502 19.1097 52.5171 18.8436C52.9619 18.4594 54.6226 16.7154 57.5583 13.5527ZM57.5583 7.55231C56.8763 6.9907 55.6012 5.77882 53.7033 3.88708C52.1613 2.32049 50.8268 1.13815 49.7 0.340072C51.3903 0.0740458 53.8516 -0.0441987 57.0542 0.0149182C61.3244 0.103593 63.9043 0.103597 64.794 0.0740386C64.9719 0.517415 64.6753 1.13814 63.8747 1.93622C63.6375 2.11357 63.2816 2.43871 62.7478 2.88209C62.2141 3.29591 61.8285 3.62105 61.621 3.82796C59.2783 6.22219 57.9142 7.46364 57.5583 7.55231ZM88.0725 27.0313C88.2207 27.4747 88.0725 27.9476 87.6277 28.4501C87.509 28.5979 87.3311 28.7753 87.0642 29.0117C86.7973 29.2482 86.6194 29.396 86.5008 29.5142C74.0164 44.5594 62.392 58.8657 51.6572 72.4922C53.5847 62.797 57.5583 47.6335 63.6078 27.0313H88.0725ZM61.0279 10.7151C61.8582 9.59185 65.0015 6.34043 70.4876 1.01991C79.8286 10.922 86.3525 18.2229 90 22.9523C88.0725 22.6567 85.285 22.6862 81.6375 23.0705C78.3163 23.3956 75.855 23.3661 74.2833 22.9523C73.5419 22.7158 71.1993 20.7354 67.3146 16.9815C63.7561 13.4936 61.6506 11.3949 61.0279 10.7151Z' fill='#F75A70' />
    },
    {
        name: 'Safira',
        color: '#4B90F0',
        icon: <Path d='M28.6455 10.7151C27.4001 12.3703 25.5022 14.4394 22.9223 16.9223C19.9865 19.7304 17.9997 21.7404 16.9914 22.9523H0.029264C-0.119007 22.4202 0.296151 21.5926 1.27474 20.4102C2.66848 18.8436 5.54494 15.6809 9.93376 10.9811C13.8185 6.81336 16.6949 3.56192 18.5928 1.28593C21.3803 3.73927 24.7312 6.90203 28.6455 10.7151ZM25.8284 27.0313C27.1925 31.8198 29.1793 39.1207 31.7592 48.9637C34.3688 58.7475 36.3556 66.0484 37.7494 70.896C37.3342 71.1325 35.8515 69.6545 33.3309 66.4918C30.5731 63.063 25.2353 56.5306 17.3176 46.865C10.3786 38.4113 5.01116 31.7902 1.24508 27.0017H25.8284V27.0313ZM31.4923 13.8187C35.7032 16.8041 38.9652 19.8486 41.2189 22.9523H23.2781C23.1892 22.3906 23.5747 21.7108 24.405 20.9127C24.5829 20.7354 24.9981 20.3807 25.5912 19.9077C26.1249 19.4643 26.5104 19.1097 26.7773 18.8436C27.4297 18.1933 28.2304 17.3657 29.209 16.3016C30.3062 15.0602 31.0772 14.2325 31.4923 13.8187ZM35.9108 4.12355C34.1019 6.01528 32.6192 7.25673 31.4923 7.90702C30.8993 7.37497 29.5352 6.10396 27.489 4.06442C25.858 2.43871 24.4643 1.19727 23.3078 0.340072C25.1167 0.0740458 27.6966 -0.0441987 30.9882 0.0149182C35.4363 0.103593 38.1052 0.103597 39.0245 0.0740386C39.2321 0.369623 38.1942 1.72931 35.9108 4.12355ZM59.1597 27.0313C52.6654 51.2397 47.9504 68.886 45.0146 80C44.4512 79.261 43.0871 74.9751 40.952 67.1421C38.6983 59.0135 35.1101 45.9783 30.2469 28.0067V27.0609H59.1597V27.0313ZM34.6653 11.0107C34.5764 10.5082 35.2584 9.65097 36.6522 8.40952C36.9784 8.08437 37.5121 7.61144 38.2238 6.99072C38.8169 6.48822 39.2024 6.19263 39.3507 6.04484C41.812 3.4437 43.354 1.78843 44.036 1.01991C45.7263 1.81799 47.6242 3.32546 49.7593 5.54235C52.1613 8.02525 53.9405 9.65097 55.0674 10.3899C53.9998 11.6018 52.3985 13.2571 50.2041 15.4149C47.9504 17.6317 46.2898 19.3166 45.2815 20.4398C45.2519 20.4398 42.6423 18.0456 37.4825 13.2275C37.3639 13.1389 36.8301 12.7842 35.8515 12.1043C35.0508 11.5131 34.6653 11.1584 34.6653 11.0107ZM57.5583 13.5527C59.0707 14.3803 60.85 15.8582 62.8664 18.016C65.0905 20.3216 66.7808 21.8586 67.967 22.6271C65.7429 22.9227 62.6589 23.0409 58.6852 22.9523C53.4068 22.9227 50.2041 22.9227 49.0773 22.9523C48.9883 22.3611 49.3738 21.6812 50.2041 20.9127C50.382 20.7354 50.7675 20.3807 51.331 19.9077C51.8647 19.4643 52.2502 19.1097 52.5171 18.8436C52.9619 18.4594 54.6226 16.7154 57.5583 13.5527ZM57.5583 7.55231C56.8763 6.9907 55.6012 5.77882 53.7033 3.88708C52.1613 2.32049 50.8268 1.13815 49.7 0.340072C51.3903 0.0740458 53.8516 -0.0441987 57.0542 0.0149182C61.3244 0.103593 63.9043 0.103597 64.794 0.0740386C64.9719 0.517415 64.6753 1.13814 63.8747 1.93622C63.6375 2.11357 63.2816 2.43871 62.7478 2.88209C62.2141 3.29591 61.8285 3.62105 61.621 3.82796C59.2783 6.22219 57.9142 7.46364 57.5583 7.55231ZM88.0725 27.0313C88.2207 27.4747 88.0725 27.9476 87.6277 28.4501C87.509 28.5979 87.3311 28.7753 87.0642 29.0117C86.7973 29.2482 86.6194 29.396 86.5008 29.5142C74.0164 44.5594 62.392 58.8657 51.6572 72.4922C53.5847 62.797 57.5583 47.6335 63.6078 27.0313H88.0725ZM61.0279 10.7151C61.8582 9.59185 65.0015 6.34043 70.4876 1.01991C79.8286 10.922 86.3525 18.2229 90 22.9523C88.0725 22.6567 85.285 22.6862 81.6375 23.0705C78.3163 23.3956 75.855 23.3661 74.2833 22.9523C73.5419 22.7158 71.1993 20.7354 67.3146 16.9815C63.7561 13.4936 61.6506 11.3949 61.0279 10.7151Z' fill='#3F89EF' />
    },
    {
        name: 'Topázio Imperial',
        color: '#DD895A',
        icon: <Path d='M28.6455 10.7151C27.4001 12.3703 25.5022 14.4394 22.9223 16.9223C19.9865 19.7304 17.9997 21.7404 16.9914 22.9523H0.029264C-0.119007 22.4202 0.296151 21.5926 1.27474 20.4102C2.66848 18.8436 5.54494 15.6809 9.93376 10.9811C13.8185 6.81336 16.6949 3.56192 18.5928 1.28593C21.3803 3.73927 24.7312 6.90203 28.6455 10.7151ZM25.8284 27.0313C27.1925 31.8198 29.1793 39.1207 31.7592 48.9637C34.3688 58.7475 36.3556 66.0484 37.7494 70.896C37.3342 71.1325 35.8515 69.6545 33.3309 66.4918C30.5731 63.063 25.2353 56.5306 17.3176 46.865C10.3786 38.4113 5.01116 31.7902 1.24508 27.0017H25.8284V27.0313ZM31.4923 13.8187C35.7032 16.8041 38.9652 19.8486 41.2189 22.9523H23.2781C23.1892 22.3906 23.5747 21.7108 24.405 20.9127C24.5829 20.7354 24.9981 20.3807 25.5912 19.9077C26.1249 19.4643 26.5104 19.1097 26.7773 18.8436C27.4297 18.1933 28.2304 17.3657 29.209 16.3016C30.3062 15.0602 31.0772 14.2325 31.4923 13.8187ZM35.9108 4.12355C34.1019 6.01528 32.6192 7.25673 31.4923 7.90702C30.8993 7.37497 29.5352 6.10396 27.489 4.06442C25.858 2.43871 24.4643 1.19727 23.3078 0.340072C25.1167 0.0740458 27.6966 -0.0441987 30.9882 0.0149182C35.4363 0.103593 38.1052 0.103597 39.0245 0.0740386C39.2321 0.369623 38.1942 1.72931 35.9108 4.12355ZM59.1597 27.0313C52.6654 51.2397 47.9504 68.886 45.0146 80C44.4512 79.261 43.0871 74.9751 40.952 67.1421C38.6983 59.0135 35.1101 45.9783 30.2469 28.0067V27.0609H59.1597V27.0313ZM34.6653 11.0107C34.5764 10.5082 35.2584 9.65097 36.6522 8.40952C36.9784 8.08437 37.5121 7.61144 38.2238 6.99072C38.8169 6.48822 39.2024 6.19263 39.3507 6.04484C41.812 3.4437 43.354 1.78843 44.036 1.01991C45.7263 1.81799 47.6242 3.32546 49.7593 5.54235C52.1613 8.02525 53.9405 9.65097 55.0674 10.3899C53.9998 11.6018 52.3985 13.2571 50.2041 15.4149C47.9504 17.6317 46.2898 19.3166 45.2815 20.4398C45.2519 20.4398 42.6423 18.0456 37.4825 13.2275C37.3639 13.1389 36.8301 12.7842 35.8515 12.1043C35.0508 11.5131 34.6653 11.1584 34.6653 11.0107ZM57.5583 13.5527C59.0707 14.3803 60.85 15.8582 62.8664 18.016C65.0905 20.3216 66.7808 21.8586 67.967 22.6271C65.7429 22.9227 62.6589 23.0409 58.6852 22.9523C53.4068 22.9227 50.2041 22.9227 49.0773 22.9523C48.9883 22.3611 49.3738 21.6812 50.2041 20.9127C50.382 20.7354 50.7675 20.3807 51.331 19.9077C51.8647 19.4643 52.2502 19.1097 52.5171 18.8436C52.9619 18.4594 54.6226 16.7154 57.5583 13.5527ZM57.5583 7.55231C56.8763 6.9907 55.6012 5.77882 53.7033 3.88708C52.1613 2.32049 50.8268 1.13815 49.7 0.340072C51.3903 0.0740458 53.8516 -0.0441987 57.0542 0.0149182C61.3244 0.103593 63.9043 0.103597 64.794 0.0740386C64.9719 0.517415 64.6753 1.13814 63.8747 1.93622C63.6375 2.11357 63.2816 2.43871 62.7478 2.88209C62.2141 3.29591 61.8285 3.62105 61.621 3.82796C59.2783 6.22219 57.9142 7.46364 57.5583 7.55231ZM88.0725 27.0313C88.2207 27.4747 88.0725 27.9476 87.6277 28.4501C87.509 28.5979 87.3311 28.7753 87.0642 29.0117C86.7973 29.2482 86.6194 29.396 86.5008 29.5142C74.0164 44.5594 62.392 58.8657 51.6572 72.4922C53.5847 62.797 57.5583 47.6335 63.6078 27.0313H88.0725ZM61.0279 10.7151C61.8582 9.59185 65.0015 6.34043 70.4876 1.01991C79.8286 10.922 86.3525 18.2229 90 22.9523C88.0725 22.6567 85.285 22.6862 81.6375 23.0705C78.3163 23.3956 75.855 23.3661 74.2833 22.9523C73.5419 22.7158 71.1993 20.7354 67.3146 16.9815C63.7561 13.4936 61.6506 11.3949 61.0279 10.7151Z' fill='#DD8C5A' />
    },
    {
        name: 'TOP Maiores',
        color: '#000000',
        icon: <Path d='M28.6455 10.7151C27.4001 12.3703 25.5022 14.4394 22.9223 16.9223C19.9865 19.7304 17.9997 21.7404 16.9914 22.9523H0.029264C-0.119007 22.4202 0.296151 21.5926 1.27474 20.4102C2.66848 18.8436 5.54494 15.6809 9.93376 10.9811C13.8185 6.81336 16.6949 3.56192 18.5928 1.28593C21.3803 3.73927 24.7312 6.90203 28.6455 10.7151ZM25.8284 27.0313C27.1925 31.8198 29.1793 39.1207 31.7592 48.9637C34.3688 58.7475 36.3556 66.0484 37.7494 70.896C37.3342 71.1325 35.8515 69.6545 33.3309 66.4918C30.5731 63.063 25.2353 56.5306 17.3176 46.865C10.3786 38.4113 5.01116 31.7902 1.24508 27.0017H25.8284V27.0313ZM31.4923 13.8187C35.7032 16.8041 38.9652 19.8486 41.2189 22.9523H23.2781C23.1892 22.3906 23.5747 21.7108 24.405 20.9127C24.5829 20.7354 24.9981 20.3807 25.5912 19.9077C26.1249 19.4643 26.5104 19.1097 26.7773 18.8436C27.4297 18.1933 28.2304 17.3657 29.209 16.3016C30.3062 15.0602 31.0772 14.2325 31.4923 13.8187ZM35.9108 4.12355C34.1019 6.01528 32.6192 7.25673 31.4923 7.90702C30.8993 7.37497 29.5352 6.10396 27.489 4.06442C25.858 2.43871 24.4643 1.19727 23.3078 0.340072C25.1167 0.0740458 27.6966 -0.0441987 30.9882 0.0149182C35.4363 0.103593 38.1052 0.103597 39.0245 0.0740386C39.2321 0.369623 38.1942 1.72931 35.9108 4.12355ZM59.1597 27.0313C52.6654 51.2397 47.9504 68.886 45.0146 80C44.4512 79.261 43.0871 74.9751 40.952 67.1421C38.6983 59.0135 35.1101 45.9783 30.2469 28.0067V27.0609H59.1597V27.0313ZM34.6653 11.0107C34.5764 10.5082 35.2584 9.65097 36.6522 8.40952C36.9784 8.08437 37.5121 7.61144 38.2238 6.99072C38.8169 6.48822 39.2024 6.19263 39.3507 6.04484C41.812 3.4437 43.354 1.78843 44.036 1.01991C45.7263 1.81799 47.6242 3.32546 49.7593 5.54235C52.1613 8.02525 53.9405 9.65097 55.0674 10.3899C53.9998 11.6018 52.3985 13.2571 50.2041 15.4149C47.9504 17.6317 46.2898 19.3166 45.2815 20.4398C45.2519 20.4398 42.6423 18.0456 37.4825 13.2275C37.3639 13.1389 36.8301 12.7842 35.8515 12.1043C35.0508 11.5131 34.6653 11.1584 34.6653 11.0107ZM57.5583 13.5527C59.0707 14.3803 60.85 15.8582 62.8664 18.016C65.0905 20.3216 66.7808 21.8586 67.967 22.6271C65.7429 22.9227 62.6589 23.0409 58.6852 22.9523C53.4068 22.9227 50.2041 22.9227 49.0773 22.9523C48.9883 22.3611 49.3738 21.6812 50.2041 20.9127C50.382 20.7354 50.7675 20.3807 51.331 19.9077C51.8647 19.4643 52.2502 19.1097 52.5171 18.8436C52.9619 18.4594 54.6226 16.7154 57.5583 13.5527ZM57.5583 7.55231C56.8763 6.9907 55.6012 5.77882 53.7033 3.88708C52.1613 2.32049 50.8268 1.13815 49.7 0.340072C51.3903 0.0740458 53.8516 -0.0441987 57.0542 0.0149182C61.3244 0.103593 63.9043 0.103597 64.794 0.0740386C64.9719 0.517415 64.6753 1.13814 63.8747 1.93622C63.6375 2.11357 63.2816 2.43871 62.7478 2.88209C62.2141 3.29591 61.8285 3.62105 61.621 3.82796C59.2783 6.22219 57.9142 7.46364 57.5583 7.55231ZM88.0725 27.0313C88.2207 27.4747 88.0725 27.9476 87.6277 28.4501C87.509 28.5979 87.3311 28.7753 87.0642 29.0117C86.7973 29.2482 86.6194 29.396 86.5008 29.5142C74.0164 44.5594 62.392 58.8657 51.6572 72.4922C53.5847 62.797 57.5583 47.6335 63.6078 27.0313H88.0725ZM61.0279 10.7151C61.8582 9.59185 65.0015 6.34043 70.4876 1.01991C79.8286 10.922 86.3525 18.2229 90 22.9523C88.0725 22.6567 85.285 22.6862 81.6375 23.0705C78.3163 23.3956 75.855 23.3661 74.2833 22.9523C73.5419 22.7158 71.1993 20.7354 67.3146 16.9815C63.7561 13.4936 61.6506 11.3949 61.0279 10.7151Z' fill='#E4E4E4' />
    }
]